import React from 'react';
import { format } from 'date-fns';
import ToggleButtonGroup from '@creditflowresearch/uilib/ToggleButtonGroup';
import CustomTimeInputSector from './CustomInputSector';
import { TIME_INPUT_SECTORS, TIME_INPUT_TYPES_VALUES, DayPart, TimeInputTypes } from './constants';
import { TIME_FORMAT_WITH_SECONDS } from '@creditflowresearch/uilib/utils/dateFormats';

import styles from './timePicker.module.scss';

interface IProps {
  /** Injected by react-datepicker through `customTimeInput` */
  date?: Date,
  increment: (value: number) => void,
  decrement: (value: number) => void,
  onChangeInput: (value: Record<string, number>) => void,
}

const CustomTimeInput = (props: IProps) => {
  const dateFormatted = format(props.date, TIME_FORMAT_WITH_SECONDS);
  const [, partOfDay] = dateFormatted.split(' ');
  const onDayPeriodButtonClick = (value: string) => {
    if (partOfDay !== value) {
      return value === DayPart.AM
          ? props.decrement(TIME_INPUT_TYPES_VALUES[DayPart.PM])
          : props.increment(TIME_INPUT_TYPES_VALUES[DayPart.PM]);
    }
    return null;
  };

  const dateValues = dateFormatted.split(':');

  const [hours, minutes, secondsPart] = dateValues;
  const [seconds] = secondsPart.split(' ');
  const value = {
    [TimeInputTypes.HOURS]: hours,
    [TimeInputTypes.MINUTES]: minutes,
    [TimeInputTypes.SECONDS]: seconds,
  };

  return (
    <div className={ styles.customTimeWrapper }>
      { TIME_INPUT_SECTORS.map(
          ({ order, ...item }) => (
            <CustomTimeInputSector
              key={ order }
              value={ value[item.type] }
              { ...item }
              increment={ props.increment }
              decrement={ props.decrement }
              onChangeInput={ props.onChangeInput }
            />
          ),
        ) }
      <ToggleButtonGroup
        className={ styles.dayPeriods }
        value={ [partOfDay] }
        onChange={ onDayPeriodButtonClick }
        orientation="vertical"
        size="S"
        ariaLabel="Part of day"
        dataTest="timePickerDayPeriodToggle"
      >
        <ToggleButtonGroup.Item value={ DayPart.AM } dataTest="timePickerDayAMButton">
          { DayPart.AM }
        </ToggleButtonGroup.Item>
        <ToggleButtonGroup.Item value={ DayPart.PM } dataTest="timePickerDayPMButton">
          { DayPart.PM }
        </ToggleButtonGroup.Item>
      </ToggleButtonGroup>
    </div>
  );
};

export default CustomTimeInput;
